import { ReactNode, RefObject, useEffect } from "react";
import { ScrollView } from "tamagui";

import { ProfileForm } from "@/forms/ProfileForm";

const ProfileFormLayout = ({
  fields,
  footer,
  currentPage,
  handleBack,
  scrollViewRef,
  onBackButtonChange,
}: {
  fields: ReactNode;
  footer: ReactNode;
  currentPage: number;
  handleBack: () => void;
  scrollViewRef: RefObject<ScrollView | null>;
  onBackButtonChange?: (show: boolean, onPress?: () => void) => void;
}) => {
  useEffect(() => {
    onBackButtonChange?.(currentPage > 1, handleBack);
  }, [currentPage, handleBack, onBackButtonChange]);

  return (
    <>
      <ScrollView
        ref={scrollViewRef}
        flex={1}
        contentContainerStyle={{
          paddingHorizontal: "$200",
          paddingBottom: "$200",
        }}
      >
        {fields}
      </ScrollView>
      {footer}
    </>
  );
};

export const ProfileFormSidebar = ({
  onClose,
  onBackButtonChange,
  onContinue,
}: {
  onClose?: () => void;
  onBackButtonChange?: (show: boolean, onPress?: () => void) => void;
  onContinue?: () => void;
}) => {
  return (
    <ProfileForm
      onSuccess={() => {
        onContinue?.();
      }}
      onError={() => onClose?.()}
      renderLayout={(props) => (
        <ProfileFormLayout {...props} onBackButtonChange={onBackButtonChange} />
      )}
    />
  );
};
